export enum AddressType {
  residence = 'residence',
  postal = 'postal',
}
